// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__19fjV","tooltip__label":"tooltip_tooltip__label__3hd3B"};